import {SHOW_NEW_NOTIFICATION_DOT} from "../../constants/headerNotification/getNotificationConst"


const initalState={
    showDot:false
}

export default function showNewNotifyReducer (state=initalState,action){
    
    switch (action.type) {
        case SHOW_NEW_NOTIFICATION_DOT:

            return{
              showDot:action?.payload
            }
         
        default:
           return state;
            
    }
}